import {ReactNode} from 'react';

import {Grid} from '@mui/material';

import {greenColors} from '../../layouts/theme/designSystem';

interface Props {
  indicators: {value: number; color: string; height?: string}[];
  bubbleAmount?: number;
  bubbleSize?: number;
  barColor?: string;
}

export const DataComparisonBar = ({indicators, bubbleAmount = 0, bubbleSize = 0, barColor}: Props) => {
  barColor = barColor || greenColors[600];

  const Bubbles = ({count}: {count: number}): ReactNode => {
    return (
      <>
        {Array.from({length: count}, (_, index) => (
          <Grid
            key={`${index}-${bubbleAmount}`}
            borderRadius={'50%'}
            zIndex={1}
            bgcolor={barColor}
            width={{xs: bubbleSize * 0.55, sm: bubbleSize * 1.05, md: bubbleSize * 1}}
            height={{xs: bubbleSize * 0.55, sm: bubbleSize * 1.05, md: bubbleSize * 1}}
            item
            data-testid={'bubble'}
          />
        ))}
      </>
    );
  };

  const BackgroundBar = () => (
    <Grid item position={'absolute'} bgcolor={barColor} height={{xs: 8, sm: 16}} width={'100%'} borderRadius={2} />
  );

  return (
    <Grid
      item
      container
      position={'relative'}
      justifyContent={'space-between'}
      boxSizing={'content-box'}
      alignItems={'center'}
      mt={4}
    >
      <BackgroundBar />
      {bubbleAmount > 0 && <Bubbles count={bubbleAmount} />}
      {indicators.map((indicator, index, arr) => {
        const isSameValueAsPrevious = index > 0 && indicator.value === arr[index - 1].value;
        const left = isSameValueAsPrevious
          ? `calc(((${indicator.value} * 100%) / ${bubbleAmount}) + 0.5% - ${bubbleSize}px)`
          : `calc((${indicator.value} * 100%) / ${bubbleAmount} - ${bubbleSize}px)`;

        return (
          <Grid
            key={`${indicator.value}-${index}`}
            item
            width={{xs: 4, sm: 8}}
            borderRadius={16}
            height={indicator.height || {xs: 48, sm: 64}}
            bgcolor={indicator.color}
            zIndex={2}
            position={'absolute'}
            left={left}
          />
        );
      })}
    </Grid>
  );
};
